import SectionLabel from "@/components/base/SectionLabel";
import { businessToolData } from "@/mocks/businessToolData";

export default function SmallStartSection() {
  return (
    <section className="py-16 md:py-22 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16 reveal">
          <SectionLabel
            label={businessToolData.smallStart.label}
            className="mb-3"
          />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5 md:mb-6">
            {businessToolData.smallStart.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            {businessToolData.smallStart.description}
          </p>
        </div>

        <div className="reveal max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
            {businessToolData.smallStart.steps.map((step, idx) => (
              <div
                key={step.num}
                className="mb-8 md:mb-10 last:mb-0 relative"
              >
                <div className="absolute -left-[35px] md:-left-[38px] top-0 w-6 h-6 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-[10px] font-bold font-label">
                  {idx + 1}
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6">
                  <span className="inline-block text-xs font-bold text-primary-500 font-label mb-1.5">
                    {step.num}
                  </span>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 font-heading">
                    {step.title}
                  </h3>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-2xl mx-auto mt-10 md:mt-12 reveal">
          <div className="flex items-start gap-3 bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5">
            <i className="ri-information-line text-secondary-500 text-lg mt-0.5 flex-shrink-0" />
            <p className="text-sm text-foreground-700 leading-relaxed">
              {businessToolData.smallStart.note}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}